export enum ApiEndpoints {
  bannerUrl = "/user/core/api/admin/v1/banner",
  publishBannerUrl = "/user/core/api/admin/v1/banner-publish",
  departmentListUrl = "/dept/core/api/admin/v1/department-list",
  serviceListUrl = "/dept/core/api/admin/v1/service-list",
  userListUrl = "/v1/users",
  userCountApiUrl = "/v1/admin/users/count",
  eventCountApiUrl = "/v1/admin/events/count",
  userDetailUrl = "/user/core/api/admin/v1/profile",
  rolesurl = "/v1/admin/roles",
  updateUserUrl = "/user/core/api/admin/v1/update-profile",

  favouriteDepartmentListUrl = "/dept/core/api/admin/v1/department-favourites-all",
  favouriteDepartmentCountListUrl = "/dept/core/api/admin/v1/department-favourites-count",
  favouriteServiceListUrl = "/dept/core/api/admin/v1/service-favourites-all",
  favouriteServiceCountListUrl = "/dept/core/api/admin/v1/service-favourites-count",
  createConfigUrl = "/scheme/core/api/scheme/v1/scheme-config",
  topRatedDepartmentUrl = "/dept/core/api/admin/v1/departments-top-rated",
  suggestedDepartmentUrl = "/dept/core/api/admin/v1/department-suggested",
  occupationListUrl = "/user/core/api/admin/v1/occupations",
  qualificationListUrl = "/user/core/api/admin/v1/qualifications",
  newUpdatedDepartmentUrl = "/dept/core/api/admin/v1/department-new-updated",
  userAllDetailsUrl = "/user/core/api/admin/v1/user-details",
  statesListUrl = "/user/core/api/admin/v1/states",
  departmentUrl = "/dept/core/api/admin/v1/departments-add",
  updateDepartmentVisibilityUrl = "/dept/core/api/admin/v1/department-visibility",
  updateDepartmentMetaDataUrl = "/dept/core/api/admin/v1/department-meta-data",
  addDepartmentTranslationUrl = "/dept/core/api/admin/v1/department-translation",
  schemeFavoriteListUrl = "/scheme/core/api/scheme/v1/get-most-favorite-schemes",
  schemeFavoriteCountListUrl = "/scheme/core/api/scheme/v1/scheme-favourites-count",
  userActivityList = "/noti/core/api/activity/get",
  systemLogsList = "/noti/core/api/system/get-logs",
  systemLogsListCount = "/noti/core/api/logs",
  userSearchActivityList = "/noti/core/api/activity/search-activity",
  apiHitsLogsList = "/dept/core/api/activity/v1/api-hit-logs",

  fetchUserPermissionUrl = "/user/core/api/admin/v1/get-user-permissions",
  userRolesurl = "/v1/admin/roles/get-user-role",
  addUserRoleUrl = "/v1/admin/roles/add-user-role",
  deleteUserRoleUrl = "/v1/admin/roles/remove-user-role",
  deletePermissionUrl = "/v1/admin/permissions/permission",

  availedServicesList = "/scheme/core/api/entity/get-availed-list",
  addNotificationUrl = "/noti/core/api/v1/pushnotification",
  addNotificationAllUrl = "/noti/core/api/v1/pushnotificationall",
  updateNotificationUrl = "/noti/core/api/v1/updatenotification",
  allNotificationURL = "/noti/core/api/v1/listallnotifications",
  departmentsCategoriesUrl = "/dept/core/api/admin/v1/department-categories/departments",
  serviceCategoriesUrl = "/dept/core/api/admin/v1/service-categories/services",
  schemeCategoriesUrl = "/dept/core/api/admin/v1/scheme-categories/schemes",
  schemeListUrl = "/scheme/core/api/scheme/v1/all-schemes",
  getEntityUrl = "/dept/core/api/admin/v1/get-entity-url",
  translationListUrl = "/dept/core/api/admin/v1/translation",
  popularSrvUrl = "/dept/core/api/admin/v1/popular-service",
  aboutUsUrl = "/dept/core/api/admin/v1/about-us",
  categoryListUrl = "/dept/core/api/admin/v1/quick-services/category",
  corCategoryListUrl = "/dept/core/api/admin/v1/core-category",
  quickServiceListUrl = "/dept/core/api/admin/v1/quick-services/services",
  cmsConfigurl = "/dept/core/api/admin/v1/cms-config",
  mostSearchedurl = "/search/core/api/search/v1/most-searched?language=en",
  doctypeUrl = "/noti/core/api/v1/digilocker-doctype",
  issuerStateUrl = "/noti/core/api/v1/digilocker-doctype/update-issuer-state",
  parentCategoryUrl = "/noti/core/api/v1/digilocker-parent-category",
  newlyAddedUrl = "/noti/core/api/v1/digilocker-elastic/newly-added-documents",
  trendingDocumentUrl = "/noti/core/api/v1/digilocker-elastic/trending-documents",
  notificationReadCountUrl = "/noti/core/api/v1/notificationReadCount",
  syncDepartmenUrl = "/dept/core/api/admin/v1/sync-departments",
  syncServicesUrl = "/dept/core/api/admin/v1/sync-services",
  syncSchemeUrl = "/scheme/core/api/scheme/v1/schemes-list",
  elasticSyncUrl = "/search/core/api/search/v1/data-sync",
  syncDocumentUrl = "/noti/core/api/v1/digilocker-elastic/sync",
  trendingUrl = "/search/core/api/search/v1/trendings",
  lastSyncUrl = "/noti/core/api/v1/sync-details",
  serviceOfDepartmentCountUrl = "/noti/core/api/v1/visits/service-counts",
  getTotalEntitiesCountUrl = "/noti/core/api/v1/total-count",
  getNewlyAddedDepartmentUrl = "/dept/core/api/admin/v1/newly-added-departments",
  getNewlyAddedServiceUrl = "/dept/core/api/admin/v1/newly-added-services",

  rolesListUrl = "/v1/admin/roles",
  roleDetailsUrl = "/v1/admin/roles/details",
  permissionsListUrl = "/v1/admin/permissions/list",
  addPermissionUrl = "/v1/admin/permissions/add-permissions",
  addRoleUrl = "/v1/admin/roles/add-role",
  editRoleUrl = "/v1/admin/roles/update-role-permission",
  issuerListUrl = "/noti/core/api/v1/digilocker-doctype/issuers",

  // url for auth
  captchaUrl = "/v1/auth/captcha",
  loginUrl = "/v1/auth/login",
  logoutUrl = "/v1/auth/logout",
  resetPasswordUrl = "/v1/users/update-password",

  // urls for bm
  hallListUrl = "/v1/admin/hall",
  eventHallLayoutListUrl = "/v1/admin/event-hall-layouts",
  duplicateEventUrl = "/v1/admin/events/duplicate-event",
  eventListUrl = "/v1/admin/events",
  eventDetailsUrl = "/v1/admin/events/details",
  stallListUrl = "/v1/admin/stall/list",
  exportStallListUrl = "/v1/admin/events/download-event-details",
  importStallsUrl = "/v1/admin/stall/import",
  pastEventListUrl = "/v1/admin/events/past-events",
  contentUrl = "/v1/content",
  getAdminContentUrl = "/v1/content/detail",
  activateContentUrl = "/v1/content/active/",
  duplicateContentUrl = "/v1/admin/content/duplicate-content",
  paginatedContentUrl = "/v1/admin/content/list",
  eventVisitUrl = "/v1/admin/search/event-visits",
  hallVisitUrl = "/v1/admin/search/hall-visits",
  stallVisitUrl = "/v1/admin/search/stall-visits",
  searchKeywordsUrl = "/v1/admin/search/search-keywords",
  provideEventAccessUrl = "/v1/admin/events/access",

  // url for dataset
  addToolkit = "/add-toolkits",
  addToolkitSteps = "/add-toolkit-steps",
  toolkitUrl = "/v1/admin/toolkits",
  toolkitSingularUrl = "/v1/admin/toolkit",
  toolkitAdminUrl = "/v1/usecase/toolkit-links",
  usecasesUrl = "/v1/usecases",
  usecasesAdminUrl = "/v1/usecase",
  resourcesUrl = "/v1/resources",
  resourcesAdminUrl = "/v1/usecase/resource",
  usecasesDetailsUrl = "/v1/usecases/usecase-details",
  usecasesDetailsAdminUrl = "/v1/usecase/usecase-details",
  resourceLinksAdminUrl = "/v1/usecase/resource-links",
  resourceLinkDeleteAdminUrl = "/v1/usecase/resource-links",
  toolkitLinksUrl = "/v1/toolkits/toolkit-links",
  publishUsecase = "/v1/usecase/publish/",

  // Dataset APIs
  searchDatasetInfoUrl = "/v1/admin/datasets/search",
  createDatasetMetadataUrl = "/v1/admin/datasets/metadata",
  updateDatasetMetadataUrl = "/v1/datasets/metadata/id",
  datasetAccessTypesUrl = "/v1/access-type",
  uploadMetadataFileUrl = "/upload/",
  fileDetailsUrl = "/v1/admin/dataset-upload/version/id/",
  datasetBaseUrl = "/v1/datasets",
  datasetVersionUrl = "/v1/admin/datasets",
  datasetUserVersionUrl = "/v1/dataset",
  downloadDatasetVersion = "/v2/dataset-download",
  datasetImportUrl = "/import-datasets/file",
  datasetListUrl = "/v1/admin/datasets",
  datasetListUrlV1 = "/v1/datasets",
  datasetVersionListUrlV1 = "/v1/dataset-versions",
  datasetUrlV1 = "/v1/dataset",
  datasetVersionUrlV1 = "/v1/dataset-version",
  datasetUploadUrl = "/v1/dataset-upload",
  datasetListUrlV2 = "/v2/admin/datasets",
  datasetDownloadLogsUrl = "/v1/artifact/stats/artifact",
  bulkThemeUpdate = "/v1/datasets/update-theme",
  datasetFlag = "/v1/admin/datasets/flag",
  publishDatasetUrl = "/v1/admin/datasets/publish/",
  manageAccessDataset = "/v1/admin/datasets/add-permission",
  getFlagReason = "/v1/admin/datasets/flag/detail/",

  // upload files
  fileUploadUrl = "/v1/admin/upload",

  // Translation URLs
  googleTranslateUrl = "https://translation.googleapis.com/language/translate/v2",
  bhashiniModelsPipelineUrl = "https://meity-auth.ulcacontrib.org/ulca/apis/v0/model/getModelsPipeline",
  bhashiniInferencePipelineUrl = "https://dhruva-api.bhashini.gov.in/services/inference/pipeline",

  // urls for models
  modelListUrlv2 = "/v2",
  modelListUrl = "/v1/models",
  modelListAdminUrl = "/v1/models",
  modelMetadataUrl = "/v1/models/metadata",
  modelMetadataAdminUrl = "/v1/models/metadata",
  masterDataUrl = "/v1/master/types",
  publishModelsUrl = "/v1/models/publish/",
  manageAccessModal = "/v1/models/add-permission",

  //upload files
  uploadModelUrl = "/v1/upload",

  //Users Urls
  getUserListUrl = "/v1/users/list",
  deleteUserUrl = "/v1/users/",
  userReviewUrl = "/v1/organization/users/review",
  userOrgListUrl = "/v1/organization/request",
  getOrgListUrl = "/v1/admin/organisation/list",
  getUserProfileUrl = "/v1/users/profile",
  createOrgUrl = "/v1/organization/users/create",
  addOrgUserUrl = "/v1/organization/users/add",
  getAllOrgUrl = "/v1/organization/users/list/org",
  updateOrgUrl = "/v1/organization/users/update/org",
  getOrgByIdUrl = "/v1/organization/users/org/",

  //stat urls
  dashboardStatsUrl = "/v1/artifact/statsAll",
  userStatsUrl = "/v1/artifact/user-stats",

  // dashboard stats
  pendingRequestsCountUrl = "/v1/dashboard/pending-requests-counts",
  usersOverviewUrl = "/v1/dashboard/users-overview",
  artifactCountUrl = "/v1/dashboard/artifact-count",
  sectorWiseArtifactCountUrl = "/v1/dashboard/sector-wise-artifact-count",
  artifactAccessCountUrl = "/v1/dashboard/artifact-access-count",
  datasetTypeCountUrl = "/v1/dashboard/dataset-type-count",
  registraionCountUrl = "/v1/dashboard/registration-count",

  //usage insights
  insightUrl = "/v1/usage-insights/summary",
  uploadCountUrl = "/v1/usage-insights/artifact-uploads",
  // uploadCountUrl = "/v1/dashboard/upload-count",
  roleWiseNoOfLoginsUrl = "/v1/usage-insights/logins",
  registrationUrl = "/v1/usage-insights/registrations",
  accountDeletionsUrl = "/v1/usage-insights/deletions",
  artefactDownloadsUrl = "/v1/usage-insights/artifact-downloads",
  contributorUpgradesUrl = "/v1/usage-insights/contributor-upgrades",
  toolkitTryoutsUrl = "/v1/usage-insights/toolkit-tryouts",
  notebookOpenedUrl = "/v1/usage-insights/notebooks-opened",
  exportInsightUrl = "/v1/usage-insights/export",
  userVisitsUrl = "/v1/users/visitor/daily-count",
  userVisitStatsUrl = "/v1/users/visitor/daily-count/details",

  getOrgUsersAdmins = "/v1/admin/organization/users/org",
  // maintenance
  getMaintenanceUrl = "/v1/maintenance",
  // permission urls
  permissionListUrl = "/v1/role-permission/find-all",
  createPermissionUrl = "/v1/role-permission/add-permission",
  permissionUrl = "/v1/role-permission",

  // user roles
  userRoleManagementListUrl = "/v1/user-role-management/list",
  userRoleAddUrl = "/v1/user-role-management/add",
  changeRoleUrl = "/v1/user-role-management/change-role",
  viewUserRoleUrl = "/v1/user-role-management/view",
  userVerifyUrl = "/v1/user-verify",
  inActiveUserUrl = "/v1/user-role-management/inactive",
  checkUserExist = "/v1/users/open/exist",

  // compoute urls
  notebookRequestDetailsUrl = "/v1/compute/notebook-request-details",
  notebookRequestsUrl = "/v1/compute/notebook-requests",
  notebookRequestStatusUpdateUrl = "/v1/compute/notebook-request-status-update",
  notebookRequestHistoryUrl = "/v1/compute/notebook-request/history",

  //Notebook Feedback urls
  notebookFeedbackUrl = "/v1/compute/notebook-feedbacks",
  notebookFeedbackForRequestUrl = "/v1/compute/notebook-feedbacks/request",

  // import urls
  importDataset = "/v1/import-dataset/import",
  importDatasetV1 = "/v1/import-dataset",
  importMaster = "/v1/import-master",
  importDatasetId = "/v1/import-dataset/id",
  importMasterId = "/v1/import-master/id",
  importMasterData = "/v1/import-master/import-master-data",
  findAllImportDatasets = "/v1/import-dataset/imports",
  deleteImportDataset = "/v1/import-dataset/delete/id",
  updateImportDataset = "/v1/import-dataset/update/id",
  publishDataset = "/v1/import-dataset/publish/id",
  createDraft = "/v1/import-master/create-master",
  publishImportMaster = "/v1/import-master/publish/id",
  getDatasetDetail = "/v1/import-dataset/detail",
  deleteMasterById = "/v1/import-master/delete-master/id",
  getDatasetStatusCountUrl = "/v1/import-dataset/dataset-status-count",
  getPublishAllUrl = "/v1/import-dataset/update-dataset-status",

  // trending weightage urls
  datasetTrendingWeightageUrl = "/v1/datasets/trending-weightage",
  modelTrendingWeightageUrl = "/v1/models/trending-weightage",
  usecaseTrendingWeightageUrl = "/v1/usecase/trending-weightage",

  // Notebook export url
  exportNotebookRequests = "/v1/compute/export-notebook-requests",
}
